var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}]},[_vm._t("default"),_c('div',{staticStyle:{"position":"relative","width":"100%","height":"210px"}},[_c('div',{staticClass:"shadow-up grey darken-4",style:('position:' +
        _vm.bottomPosition +
        '; left: 0px; width: 100%; height: 210px; z-index: 1; bottom: ' +
        _vm.bottomHeight +
        'px;')},[_vm._t("bar"),_c('dog-footer',{staticStyle:{"position":"absolute","top":"0px","z-index":"-1"}})],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }